import { useState } from 'react';
import { IoTrashOutline } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';

import Error from '../Error';
import Loader from '../Loader';
// import Error from '../Error';
// import Loader from '../Loader';
import Pagination from '../Pagination';
import FilePreviewModal from '../utils/FilePreviewModal';
import DrawerModel from '../utils/drawer';
import { tableBackgroundColor } from '../utils/tableBackgroundColor';
import { formatDisplayDate } from '../utils/timeFormatter';
import { CreateBlog } from './CreateBlog';

import { BlogError } from '@/exceptions/blog/blog.enum';
import useDeleteBlog from '@/hooks/blog/useDeleteBlog';
import { useGetAllBlogs } from '@/hooks/blog/useGetAllBlogs';
import { DrawerBlog, Iblog } from '@/interfaces/entities/blog';
import { notificationService } from '@/services/notification.service';

const BlogTable = () => {
	const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
	const [isBlog, setIsBlog] = useState<Iblog | null>();
	const [currentPage, setCurrentPage] = useState(1);
	const [modalVisible, setModalVisible] = useState(false);
	const [url, setUrl] = useState('');
	const navigate = useNavigate();

	const { blogs, isLoading, isError, error, totalPages, isPending } =
		useGetAllBlogs(currentPage);
	const deletBlog = useDeleteBlog();

	if (isLoading || isPending) {
		return <Loader />;
	}

	if (isError) {
		return <Error message={error ? error.message : BlogError.BLOG_ERROR} />;
	}

	const openEditModal = (blogger: Iblog) => {
		setIsBlog(blogger);
		setIsCreateModalOpen(true);
		console.log(blogger, 'bloger');
	};

	const openCreateModal = () => {
		setIsCreateModalOpen(true);
	};

	const handlePreview = (url: string | null) => {
		if (url) {
			setUrl(url);
			setModalVisible(true);
		}
	};

	const handleDelete = async (id: number) => {
		try {
			await deletBlog.mutate(id);
		} catch (error) {
			notificationService.error('blog deleted failed');
		}
	};

	const handleToggle = () => {
		setIsCreateModalOpen(false);
		setIsBlog(null);
	};
	return (
		<>
			<div className="px-4 sm:px-6 lg:px-8 w-full mb-10">
				<div className="sm:flex sm:items-center">
					<div className="flex justify-between font-bold sm:flex-auto">
						<h1
							data-test="h1-categories"
							className="text-base font-semibold leading-6 text-gray-900"
						>
							Blog
						</h1>
						<button
							className="text-indigo-600 hover:text-indigo-900"
							data-test="button-add-category"
							onClick={openCreateModal}
						>
							Add Blog
						</button>
					</div>
				</div>
				{blogs.length ? (
					<div className="mt-8 w-full  flow-root">
					<div className=" w-full overflow-x-auto">
						<div className="inline-block  min-w-[1000px] w-full py-2 align-middle">
								<table className="min-w-full table-auto divide-y divide-gray-300 border-red-300  border-spacing-x-4">
									<thead>
										<tr className="gap-x-2">
											<th
												scope="col"
												className="w-1/12  py-3.5 text-center text-sm font-semibold text-gray-900 "
												data-test="th-id"
											>
												ID
											</th>
											<th
												scope="col"
												className="w-2/12 py-3.5 text-center text-sm font-semibold text-gray-900"
												data-test="th-name"
											>
												Title
											</th>
											<th
												scope="col"
												className="w-2.5/12 py-3.5 text-center text-sm font-semibold text-gray-900"
												data-test="th-heading"
											>
												Heading
											</th>
											<th
												scope="col"
												className="w-2.5/12 py-3.5 text-center text-sm font-semibold text-gray-900"
												data-test="th-description"
											>
												Description
											</th>

											<th
												scope="col"
												className="w-1/12 py-3.5 text-center text-sm font-semibold text-gray-900"
												data-test="th-date"
											>
												Date
											</th>
											<th
												scope="col"
												className="w-1/12 py-3.5 text-center text-sm font-semibold text-gray-900"
												data-test="th-image"
											>
												image
											</th>

											<th
												scope="col"
												className="w-1/12 py-3.5 text-center text-sm font-semibold text-gray-900"
												data-test="th-comments"
											>
												Comments
											</th>
											<th
												scope="col"
												className="w-1/12  py-3.5 text-center text-sm font-semibold text-gray-900"
												data-test="th-actions"
											>
												Actions
											</th>
										</tr>
									</thead>
									<tbody className="divide-y divide-gray-200">
										{blogs
											.slice()
											.sort(
												(a, b) =>
													new Date(b.date || '').getTime() -
													new Date(a.date || '').getTime(),
											)
											.map((blog: Iblog, index) => {
												return (
													<tr
														key={blog.id}
														className={`${tableBackgroundColor(
															index,
														)} hover:bg-gray-200 min-h-8 gap-x-2`}
													>
														<td
															data-test="td-id"
															className="text-center max-w-sm py-4  text-sm font-medium text-gray-900 "
														>
															{blog.id}
														</td>
														<td
															data-test="td-name"
															className="text-center max-w-md py-4 text-sm text-gray-500"
														>
															{blog.title}
														</td>
														<td
															data-test="td-description"
															className="text-center max-w-md py-4 text-sm text-gray-500"
														>
															{blog.heading}
														</td>
														<td
															data-test="td-description"
															className="text-center max-w-md py-4 text-sm text-gray-500"
														>
															{blog.description.length > 100
																? `${blog.description.slice(0, 100)}...`
																: blog.description}
														</td>
														<td
															data-test="td-date"
															className="text-center max-w-md py-4 text-sm text-gray-500"
														>
															{formatDisplayDate(blog.date)}
														</td>
														<td
															data-test="td-image"
															className="text-center max-w-md py-4 text-sm text-gray-500"
														>
															<button
																data-test="image-button"
																className="text-indigo-600 hover:text-indigo-900 text-[16px] font-semibold"
																onClick={() => handlePreview(blog.img)}
															>
																View
															</button>
														</td>
														<td
															data-test="td-comments"
															className="text-center max-w-md py-4 text-sm text-gray-500"
														>
															<button
																data-test="comments-button"
																className="text-indigo-600 hover:text-indigo-900 text-[16px] font-semibold"
																onClick={() =>
																	navigate(`/comments/blog/${blog.id}`)
																}
															>
																View
																<span className="sr-only">{blog.id}</span>
															</button>
														</td>
														<td
															data-test="edit-notification-button"
															className="text-center text-md font-semibold "
														>
															<div className="flex justify-center items-center gap-6">
																<button
																	data-test="edit-blog-button"
																	className="text-indigo-600 hover:text-indigo-900"
																	onClick={() => openEditModal(blog)}
																>
																	Edit
																	<span className="sr-only">{blog.id}</span>
																</button>

																<IoTrashOutline
																	className="cursor-pointer"
																	onClick={() => handleDelete(blog.id)}
																/>
															</div>
														</td>
													</tr>
												);
											})}
									</tbody>
								</table>
							</div>
						</div>
						<Pagination
							currentPage={currentPage}
							setCurrentPage={setCurrentPage}
							totalPages={totalPages as number}
						/>
					</div>
				) : (
					<div className="w-full">
						<h1
							data-test="h1-blogs"
							className="text-base font-semibold text-center mt-20 leading-6 text-gray-900"
						>
							No Blogs Available
						</h1>
					</div>
				)}
				<FilePreviewModal
					visible={modalVisible}
					url={url}
					onClose={() => setModalVisible(false)}
				/>
			</div>
			<DrawerModel
				isOpen={isCreateModalOpen}
				isTitle={isBlog ? DrawerBlog.Edit : DrawerBlog.Create}
				setToggle={handleToggle}
			>
				<CreateBlog editBlog={isBlog ?? null} setToggle={handleToggle} />
			</DrawerModel>
		</>
	);
};

export default BlogTable;
